import React, { Dispatch, FC, useRef } from 'react'
import './MinimumWageForm.scss'
import { Button, Select } from '../../../../../../ps-aspect-design';
import { Input } from 'ps-design';
import { US_STATES_WITH_ABBR } from '../../../../../../constants/USStates';
import { USState } from '../../../../../../lib/types';
import { stateAbbrToName, stateNameToAbbr, formatDate, formatCalDate } from '../helpers';
import { MinimumWageReducerAction, MinimumWageModalFormI } from '../store';
import { DatePicker } from '@mantine/dates';
interface MinimumWageFormPropsI {
  formState: MinimumWageModalFormI
  dispatch: Dispatch<MinimumWageReducerAction>
}

export const MinimumWageForm: FC<MinimumWageFormPropsI> = ({ formState, dispatch }) => {
  const { state, city, minimum_wage, effective_date, showCal } = formState
  const ref = useRef() // Not sure why a ref is required for Select Input

  return (
    <div className='minimum-wage-form'>
      <div className='minimum-wage-form__state-select'>
        <label className='minimum-wage-form__state-select__label'>State</label>
        <Select
          componentRef={ref as any}
          disabled={false}
          handleChange={(val: USState) => dispatch({ type: 'SET_STATE', payload: stateNameToAbbr(val) })}
          options={US_STATES_WITH_ABBR.map(state => ({ text: state.label, key: state.label }))}
          value={stateAbbrToName(state)}
        />
      </div>
      <div className='minimum-wage-form__field'>
        <label>City</label>
        <Input
          value={city}
          onChange={(_: undefined, val: string) => dispatch({ type: 'SET_CITY', payload: val })}
        />
      </div>
      <div className='minimum-wage-form__field'>
        <label>Minimum Wage</label>
        <Input
          type='currency'
          displayFormatted
          minNumberOfDecimals={0}
          maxNumberOfDecimals={2}
          value={minimum_wage}
          onChange={(_: undefined, val: string) => dispatch({ type: 'SET_WAGE', payload: val })}
        />
      </div>
      <div className='minimum-wage-form__field'>
        <label>Effective Date</label>
        <div className='minimum-wage-form__field__effective-date'>
          <Input value={formatDate(effective_date)} disabled />
          <Button icon='Calendar' onClick={() => dispatch({ type: 'SET_CAL_OPEN', payload: !showCal })}></Button>
        </div>
        {showCal && <div className='minimum-wage-form__field__effective-date-calendar'>
          <DatePicker  
            size="lg"
            onChange={(date: Date) => dispatch({ type: 'SET_EFFECTIVE_DATE', payload: formatCalDate(date) })}
            />
        </div>
        }
      </div>
    </div>
  )
}